import React from "react"

export interface AuthContextData {
  isAuthenticated?: boolean
  isAdmin?: boolean
  pid?: string | null
  email?: string | null
  name?: string | null
  isImpersonated?: boolean
}

export const AuthContext = React.createContext<AuthContextData | undefined>(undefined)

/*
 * Hook that provides access to authenticated user information.
 */
export function useAuth(): AuthContextData {
  const context = React.useContext(AuthContext)
  if (context === undefined) {
    console.warn("useAuth should be used within an AuthProvider")
    return {
      isAdmin: false,
      isAuthenticated: false,
    }
  }
  return context
}
